module.exports = __webpack_public_path__ + "static/img/sys-bg-btm.f64f5967.png";